import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Palestra/Palestra1.jpeg"
import foto2 from "../images/Palestra/palestra2.jpeg"
import foto3 from "../images/Palestra/palestra3.jpeg"


function Palestra() {
    return(
        <div>
            <div className="title d-flex flex-row m-4">
                <p className="display-4 fw-bold m-auto" style={{color: "#41B6F4"}}>PALESTRA</p>
            </div>
            <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} />
            <hr/>
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p>Inserire testo...</p>
                </blockquote>
            </figure>
            <hr/>

            <hr/>
        </div>
    )
}


export default Palestra
